








































































































































































































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
// import { decorationData, questionData, testData, QuestionDataType } from "../../config/questionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";

@Component({
  name: "logicSet",
  components: {},
  filters: {},
})
export default class QuestionnaireEdit extends Vue {
  @PropSync("modalVisible", { type: Boolean }) visible!: Boolean;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;
  @Watch("visible")
  inputValChange(val: any) {
    if (val) {
      // this.findRewardingActivity();
      this.initIfItems();
      this.initPostForm();
    }
  }
  ifItems: any = [];
  noneDecoItems: any = [];
  private localSubmit = {};
  private postForm: any = {
    itemShowLogics: [],
  };

  // private rules = {
  //   title: [{ required: true, type: "string", message: "请填写标题", trigger: "blur" }],
  // };

  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  get formLogicConfig() {
    return QuestionnaireEditModule.formLogicConfig;
  }

  private uniqueArr = [25, 26, 27, 28, 29];

  // 创建显示逻辑的默认结构
  createLogicItem() {
    return {
      nextItem: [],
      itemOptions: [],
      thenEffect: "",
      operate: "",
      ifItem: "",
      ifItemIndex: "",
      ifItemIsRadio: false,
      ifItemOptions: [],
      multiOperate: "",
      multiItems: [],
    };
  }
  // 创建附加条件的默认结构
  createMultiItem() {
    return {
      ifItem: "",
      operate: "",
      itemOptions: [],
      ifItemIndex: "",
      ifItemOptions: [],
      ifItemIsRadio: false,
    };
  }
  deleteLogic(index: number) {
    this.postForm.itemShowLogics.splice(index, 1);
  }
  addLogic() {
    this.postForm.itemShowLogics.push(this.createLogicItem());
  }
  // 根据选择题目刷新主条件选项
  ifItemChange(value: any, index: any) {
    console.log("ifItemChange", value, index);
    if (value) {
      let oifItemIndex: any = this.noneDecoItems.findIndex((item: any) => {
        return item.data.id == value;
      });
      if (oifItemIndex >= 0) {
        this.postForm.itemShowLogics[index].ifItemIndex = oifItemIndex;
        const oifItem: any = this.noneDecoItems[oifItemIndex];
        this.postForm.itemShowLogics[index].itemOptions = [];
        this.postForm.itemShowLogics[index].nextItem = [];
        this.postForm.itemShowLogics[index].ifItemOptions = oifItem.data.optionsList;
        this.postForm.itemShowLogics[index].ifItemIsRadio = oifItem.data.type == 1 || oifItem.data.type == 9;
      }
    }
  }
  // 切换附加条件关系时同步附加条件数据
  multiOperateChange(value: any, index: number) {
    const showLogic = this.postForm.itemShowLogics[index];
    if (!value) {
      this.$set(showLogic, "multiItems", []);
      return;
    }
    if (!Array.isArray(showLogic.multiItems) || showLogic.multiItems.length == 0) {
      this.$set(showLogic, "multiItems", [this.createMultiItem()]);
    }
  }
  addMultiItem(logicIndex: number, multiIndex: number) {
    this.postForm.itemShowLogics[logicIndex].multiItems.splice(multiIndex + 1, 0, this.createMultiItem());
  }
  deleteMultiItem(logicIndex: number, multiIndex: number) {
    const multiItems = this.postForm.itemShowLogics[logicIndex].multiItems;
    if (multiItems.length <= 1) {
      return;
    }
    multiItems.splice(multiIndex, 1);
  }
  // 根据选择题目刷新附加条件选项
  multiIfItemChange(value: any, logicIndex: number, multiIndex: number) {
    const multiItem = this.postForm.itemShowLogics[logicIndex].multiItems[multiIndex];
    if (value) {
      let oifItemIndex: any = this.noneDecoItems.findIndex((item: any) => {
        return item.data.id == value;
      });
      if (oifItemIndex >= 0) {
        const oifItem: any = this.noneDecoItems[oifItemIndex];
        multiItem.ifItemIndex = oifItemIndex;
        multiItem.itemOptions = [];
        multiItem.ifItemOptions = oifItem.data.optionsList;
        multiItem.ifItemIsRadio = oifItem.data.type == 1 || oifItem.data.type == 9;
        this.postForm.itemShowLogics[logicIndex].nextItem = [];
      }
    }
  }
  thenEffectChange(value: any, index: any) {
    if (value == "HIDEALL") {
      this.postForm.itemShowLogics[index].nextItem = [];
    }
  }
  // 题目和选项展示工具
  formatOptionLabel(item: any, opidx: number) {
    return String(item.content).startsWith("http") ? "选项" + (opidx + 1) : item.content;
  }
  getLogicConditionIds(showLogic: any) {
    const ids = [];
    if (showLogic.ifItem) {
      ids.push(showLogic.ifItem);
    }
    if (showLogic.multiOperate && Array.isArray(showLogic.multiItems)) {
      showLogic.multiItems.forEach((multiItem: any) => {
        if (multiItem.ifItem) {
          ids.push(multiItem.ifItem);
        }
      });
    }
    return ids;
  }
  getLogicMaxConditionIndex(showLogic: any) {
    const conditionIds = this.getLogicConditionIds(showLogic);
    return conditionIds.reduce((maxIndex: number, id: any) => {
      const itemIndex = this.noneDecoItems.findIndex((item: any) => {
        return item.data.id == id;
      });
      return itemIndex > maxIndex ? itemIndex : maxIndex;
    }, -1);
  }
  isSameValue(value1: any, value2: any) {
    return value1 !== "" && value1 !== undefined && value1 !== null && value1 == value2;
  }
  isMainIfItemDisabled(showLogic: any, itemId: any) {
    if (!showLogic.multiOperate || !Array.isArray(showLogic.multiItems)) {
      return false;
    }
    return showLogic.multiItems.some((multiItem: any) => {
      return this.isSameValue(multiItem.ifItem, itemId);
    });
  }
  isMultiIfItemDisabled(showLogic: any, multiIndex: number, itemId: any) {
    if (this.isSameValue(showLogic.ifItem, itemId)) {
      return true;
    }
    if (!Array.isArray(showLogic.multiItems)) {
      return false;
    }
    return showLogic.multiItems.some((multiItem: any, index: number) => {
      return index != multiIndex && this.isSameValue(multiItem.ifItem, itemId);
    });
  }
  isNextItemDisabled(showLogic: any, item: any, ndIndex: number) {
    const conditionIds = this.getLogicConditionIds(showLogic);
    const isConditionItem = conditionIds.some((id: any) => {
      return this.isSameValue(id, item.data.id);
    });
    return isConditionItem || ndIndex <= this.getLogicMaxConditionIndex(showLogic) || this.uniqueArr.includes(item.componentName);
  }
  validateConditionUnique(logicIndex: number) {
    const showLogic = this.postForm.itemShowLogics[logicIndex];
    const conditionIds = this.getLogicConditionIds(showLogic);
    const validIds = conditionIds.filter((id: any) => {
      return id !== "" && id !== undefined && id !== null;
    });
    const uniqueIds = new Set(validIds.map((id: any) => String(id)));
    return validIds.length == uniqueIds.size;
  }
  validateIfItem(rule: any, value: string, callback: any) {
    let ifitemExist = this.noneDecoItems.some((nitem: any) => {
      return nitem.data.id == value;
    });
    if (!ifitemExist) {
      callback(new Error("该选项已失效"));
    } else if (rule.field && !this.validateConditionUnique(Number(rule.field.split(".")[1]))) {
      callback(new Error("同一条规则内条件题不能重复"));
    } else {
      callback();
    }
  }
  validateItemOptions(rule: any, value: any, callback: any) {
    let logicIndex = rule.field.split(".")[1];
    let ifItemOptions = this.postForm.itemShowLogics[logicIndex].ifItemOptions;
    if (!Array.isArray(value) || value.length == 0) {
      return callback(new Error("请选择选项"));
    }
    const itemExist = value.every((id: string) => {
      return ifItemOptions.some((op: any) => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  // 校验附加条件关系和附加条件列表是否匹配
  validateMultiOperate(rule: any, value: string, callback: any) {
    const logicIndex = Number(rule.field.split(".")[1]);
    const showLogic = this.postForm.itemShowLogics[logicIndex];
    if (value && (!Array.isArray(showLogic.multiItems) || showLogic.multiItems.length == 0)) {
      callback(new Error("请添加附加条件"));
    } else {
      callback();
    }
  }
  validateMultiIfItem(rule: any, value: string, callback: any) {
    let logicIndex = Number(rule.field.split(".")[1]);
    let ifitemExist = this.noneDecoItems.some((nitem: any) => {
      return nitem.data.id == value;
    });
    if (!ifitemExist) {
      callback(new Error("该选项已失效"));
    } else if (!this.validateConditionUnique(logicIndex)) {
      callback(new Error("同一条规则内条件题不能重复"));
    } else {
      callback();
    }
  }
  validateMultiItemOptions(rule: any, value: any, callback: any) {
    const fieldList = rule.field.split(".");
    const logicIndex = Number(fieldList[1]);
    const multiIndex = Number(fieldList[3]);
    const multiItem = this.postForm.itemShowLogics[logicIndex].multiItems[multiIndex];
    const ifItemOptions = multiItem.ifItemOptions || [];
    if (!Array.isArray(value) || value.length == 0) {
      return callback(new Error("请选择选项"));
    }
    const itemExist = value.every((id: string) => {
      return ifItemOptions.some((op: any) => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  // validateItemOption(rule: any, value: Array<string>, callback: any) {
  //   let sameLogic = this.postForm.itemShowLogics.filter((item: any) => {
  //     return item.itemOptions.sort().toString() == value.sort().toString();
  //   });

  //   if (sameLogic.length > 1) {
  //     callback(new Error("操作项目已失效 请重选"));
  //   } else {
  //     callback();
  //   }
  // }
  validateNextItem(rule: any, value: Array<string>, callback: any) {
    // let sameLogic = this.postForm.itemShowLogics.filter((item: any) => {
    //   return item.nextItem == value;
    // });

    // if (sameLogic.length > 1) {
    //   callback(new Error("与已有逻辑冲突，请重新设置"));
    // } else {
    // console.log("validateNextItem", rule.field);
    if (rule.field) {
      let logicIndex = rule.field.split(".")[1];
      if (!Array.isArray(value) || value.length == 0) {
        return callback(new Error("请选择题目"));
      }
      const uniqueIds = new Set(value.map((id: any) => String(id)));
      if (uniqueIds.size != value.length) {
        return callback(new Error("同一条规则内目标题不能重复"));
      }
      let findEmpty = value.some((id: any) => {
        return !this.noneDecoItems.some((nitem: any) => {
          return nitem.data.id == id;
        });
      });
      if (findEmpty) {
        return callback(Error("操作项目已失效 请重选"));
      }
      let findWrongSort = value.some((id: any) => {
        let nextIndex = this.noneDecoItems.findIndex((nitem: any) => {
          return nitem.data.id == id;
        });
        return nextIndex <= this.getLogicMaxConditionIndex(this.postForm.itemShowLogics[logicIndex]);
      });
      if (findWrongSort) {
        return callback(Error("排序已失效"));
      }

      return callback();
    }
    // }
  }
  initIfItems() {
    let dataList = JSON.parse(JSON.stringify(this.dataList));

    this.noneDecoItems = dataList.filter((item: any) => {
      return ![15, 16, 5, 8, 24].includes(item.componentName);
    });
    this.noneDecoItems.forEach((item: any, index: string) => {
      item.index = index + 1;
    });
    this.ifItems = dataList.filter((item: any) => {
      return [1, 2, 9, 10, 27].includes(item.componentName);
    });
    // this.ifItems.forEach((item: any) => {
    //   item.index =
    //     this.noneDecoItems.findIndex((item: any) => {
    //       return item.data.id == item.data.id;
    //     }) + 1;
    // });
  }
  setItemMeta(target: any, ifItem: any) {
    let oifItemIndex: any = this.noneDecoItems.findIndex((item: any) => {
      return item.data.id == ifItem;
    });
    if (oifItemIndex >= 0) {
      const oifItem: any = this.noneDecoItems[oifItemIndex];
      target.ifItemIndex = oifItemIndex;
      target.ifItemOptions = oifItem.data.optionsList;
      target.ifItemIsRadio = oifItem.data.type == 1 || oifItem.data.type == 9;
    } else {
      target.ifItemIndex = 0;
      target.ifItemOptions = [];
      target.ifItemIsRadio = false;
    }
  }
  normalizeShowLogic(logic: any) {
    if (!Object.prototype.hasOwnProperty.call(logic, "multiOperate")) {
      this.$set(logic, "multiOperate", "");
    }
    if (!Array.isArray(logic.multiItems)) {
      this.$set(logic, "multiItems", []);
    }
    if (!logic.multiOperate) {
      logic.multiOperate = "";
      logic.multiItems = [];
    } else if (logic.multiItems.length == 0) {
      logic.multiItems = [this.createMultiItem()];
    }
    logic.multiItems.forEach((multiItem: any) => {
      Object.assign(multiItem, Object.assign(this.createMultiItem(), multiItem));
      this.setItemMeta(multiItem, multiItem.ifItem);
    });
  }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }

  initPostForm() {
    let postForm = JSON.parse(JSON.stringify(this.formLogicConfig));
    postForm.itemShowLogics.forEach((logic: any) => {
      this.normalizeShowLogic(logic);
      this.setItemMeta(logic, logic.ifItem);
    });
    this.postForm = postForm;
  }

  // $ handleModules

  getModulesConfigInstance() {
    return this.$refs.modulesConfig as any;
  }

  getSubmitConfigInstance() {
    return this.$refs.submitConfig as any;
  }
  async validateForSave() {
    // 保存总配置时,用来最终效验有没有失效项目
    this.clearValidate();

    console.log("logicSetvalidateForSave");
    this.initIfItems();
    this.initPostForm();
    return await this.validate();
  }
  async validate() {
    if (this.postForm.itemShowLogics.length == 0) {
      QuestionnaireEditModule.SET_FORM_LOGIC_CONFIG(this.postForm);
      return true;
    }
    if (!this.getFormInstance()) {
      this.visible = true;
      return false;
    }
    let result = await this.getFormInstance()
      .validate()
      .catch(() => {
        return false;
      });
    console.log("itemShowLogicsValidate", result);
    if (result) {
      this.postForm.itemShowLogics.forEach((logic: any) => {
        if (!logic.multiOperate) {
          logic.multiItems = [];
        }
      });
      QuestionnaireEditModule.SET_FORM_LOGIC_CONFIG(this.postForm);
    }
    return result;
  }
  closeDialog() {
    this.initPostForm();
    this.visible = false;
  }
  async handleCommit() {
    let vali = await this.validate();
    console.log("validate", vali);
    if (vali) {
      this.visible = false;
    }
  }
}
